<template>
    <a-select :placeholder="placeholder" allowClear style="width:90px" v-model="item[itemKey]" @change="change()">
        <a-select-option
        v-for="type in options"
        :key="type.id"
        :value="type.id" >{{ type.industryCategoryName }}</a-select-option>
    </a-select>
</template>
<script>
export default {
    data(){
        return {}
    },
    props:{
        item:{
            type:Object,
            default:()=>({})
        },
        maxLength:{
            type:Number,
            default:100000
        },
        // 键名
        itemKey:{
            type:String,
            default:''
        },
        placeholder:{
            type:String,
            default:'请输入' 
        },
        type:{
            type:String,
            default:'string',//string,number
        },
        options:{
            type:Array,
            default:()=>[]
        },
        index:{
            type:Number,
            default:0
        }


    },
    watch:{
        options:{
            handler(){
                // console.log(this.options,'00000')
            },
            deep:true,
            immediate:true
        },
        item:{
            handler(){},
            deep:true,
            immediate:true
        }
    },
    methods:{
        change(){
            if(this.itemKey === 'industryCategoryId' || this.itemKey === 'industrySubclassId'){
                this.$emit('change',this.item,this.index)
            }
            if(this.itemKey === 'industryCategoryId'){
                if(!this.item[this.itemKey]){
                    this.item.industryCategoryName = ''
                }
                
            }
            if(this.itemKey === 'industrySubclassId'){
                if(!this.item[this.itemKey]){
                    this.item.industrySubclassName = ''
                }
                
            }
        }
    }
}
</script>